import React from "react";
import "tw-elements";
import SupportAdCard from "../Ads/SupportAdCard";
import CampaignCard from "../CampaignCard";

const HomeCase = () => {
  const img = [
    { img: "assets/images/paypal.png" },
    { img: "assets/images/amazon.png" },
    { img: "assets/images/walmart.png" },
  ];
  const fundRaise = [
    {
      title: "SET-UP IS FREE",
      content: "There is NO-COST to get Started. Let us Help You!",
    },
    {
      title: "TRUST",
      content:
        "Donors have the ability to proactively view items purchased, in return, receiving detailed receipts for each & every donation!",
    },
    {
      title: "SUCCESS",
      content:
        "Maximize your ability to reach a greater audience through our FREE Gaming App Learn more: https://e1wgames.com/",
    },
  ];

  return (
    <div className="bg-white flex flex-col w-full">
      <SupportAdCard />
      <CampaignCard />
      {/* ukraine needs help section */}

      <div className="container mx-auto flex flex-col lg:flex-row gap-10 my-10">
        <div className="flex flex-col items-start justify-start px-4">
          <p className="font-extrabold text-primary text-3xl lg:text-5xl">
            Ukraine Needs Your Help!
          </p>
          <p className="text-md lg:text-xl  py-10 ">
            The fighting in Ukraine continues to escalate. Day by day, thousands
            of refugees are needing your help. The delivery of life saving
            services is time sensitive as people are fighting for their survival
            everyday. Funds donated will help provide food, medicine, shelter
            and other life support to Ukraine. Women, children and the elderly
            are amongst those that are in high risk and your action is critical.
            Make your donation now and save a life. Together, let's support
            Ukraine.
          </p>
          <button className="bg-primary rounded-full text-lg px-4 py-2 lg:px-6 lg:py-2 font-semibold lg:text-2xl text-light ">
            Donate Now
          </button>
        </div>
        <img
          src={process.env.PUBLIC_URL + "assets/images/ukraine.jpg"}
          alt="Covid"
          className="container mx-auto lg:w-2/4 object-cover"
        />
      </div>

      {/* start campaign ads section */}

      <div className=" py-20 bg-primary">
        <div className="container mx-auto h-full flex flex-col gap-10 items-center px-2">
          <p className=" text-center text-lg lg:text-4xl font-extrabold text-light">
            Join thousands who get funded each year through our unique model
            that connect Donors, Recipients, Corporate Partners & Volunteers!
          </p>
          <div className="flex justify-between">
            {/* <div className="h-full bg-secondary text-center">ads</div> */}
            <div className="h-full flex flex-col">
              <div className="flex gap-5 lg:gap-10">
                <button className="bg-yellow  px-2 py-2 lg:py-2 lg:px-8 rounded-full">
                  Start a Campaign
                </button>
                <button className="bg-primary px-2 py-2 lg:py-2 lg:px-8 rounded-full border border-light text-light">
                  Watch a Video
                </button>
              </div>
              {/* <div className="h-full  w-full bg-secondary text-center">
                ADS
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* WHY RAISE FUND SECTION */}

      <div className="flex flex-col gap-12 grad-sec py-14 px-4">
        <div className="container mx-auto flex flex-col items-center lg:flex-row">
          <div className="flex flex-col gap-6">
            <h1 className="text-2xl font-extrabold lg:text-5xl text-primary">
              Why Raise Fund With Us?
            </h1>
            <p className="text-lg lg:text-2xl font-normal text-[#242424]">
              Unlike many other online platforms, DonorAssist DOES NOT forward
              any money to our recipients, only goods and services predetermined
              on a recipients Charity Registry “Wish-List”.
            </p>
          </div>
          <img
            src={process.env.PUBLIC_URL + "assets/images/cr11.png"}
            alt="charity logo"
            className="w-[300px] lg:w-[400px]"
          />
        </div>
        <div className="w-full flex flex-col justify-center gap-4 lg:flex-row container lg:mx-auto">
          {fundRaise.map((obj, i) => {
            return (
              <React.Fragment>
                <div className="lg:w-[33.33%] h-[200px] border-primary border-solid border-l-2 pl-2 border border-r-transparent border-t-transparent  border-b-transparent  ">
                  <h1 className=" font-extrabold text-2xl text-primary ">
                    {obj.title}
                  </h1>
                  <p className=" text-lg text-[#242424]">{obj.content}</p>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>

      {/* services help section */}

      <div className="container mx-auto flex flex-col gap-20 my-10 px-4">
        <div className="text-center text-xl lg:text-4xl font-extrabold text-primary">
          Be a Corporate Partner today! Let's Discuss How Your Products/Services
          Help Those in Need.
        </div>
        <div>
          <div className="flex flex-wrap justify-center gap-10 items-center">
            {img.map((item, index) => {
              return (
                <img
                  src={process.env.PUBLIC_URL + item.img}
                  alt={index}
                  className="w-[100px] lg:w-[200px]"
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCase;
